import React from "react";
import { ButtonPreview } from "./ElementsPreview";

const DropdownNavigatePreview = ({ config }) => {
  return (
    <div className="d_flex gap_2">
      <select className="builder_input" style={{ maxWidth: "200px" }} disabled>
        <option>{config.name}</option>
      </select>
      <ButtonPreview config={config.button} />
    </div>
  );
};

export default DropdownNavigatePreview;
